module.exports = __webpack_public_path__ + "img/customer-perspective.58c3b745.png";